// @format

export function initCreditBatches(): void {
  $(document).on('change', '#credit-batches-company-dropdown select', e => {
    $('#credit-batches-company-dropdown').submit();
  });
}
